import $ from "jquery";

let BASE_URL = 'https://theprojectstagingserver.com/neuro-diagnostics-stage/';

// let BASE_URL = 'http://ndp.apptestonline.com/neuro-diagnostics-stage/';

export const CONFIG = {
    APP_NAME : 'Neuro Diagnostics',
    API_URL  : BASE_URL + 'public/api',
    // API_URL  : 'http://ndp.apptestonline.com/neuro-diagnostics-stage/public/api',
    //API_URL  : 'http://localhost/neuro-diagnostics/public/api',
    RECORDS_PER_PAGE : 10 ,
    CONST_STATUS_ACTIVE : 1 ,
    CONST_SURGEON_ROLE :'surgeon',
    MAIL_SUBJECT:'',
    MAIL_BODY:'',
    GENERAL_MESSAGE: 'Something went wrong.',
    API_ERROR_MESSAGE:'This feature is only available online. Connect to the internet and try again.',
    PROFILE_UPDATE_MESSAGE: 'Your profile has been successfully updated.',
    PROFILE_DRAFT_MESSAGE: 'Your changes have been saved. Make sure you publish them once ready.',
    EXPERIENCE_LIMIT_MESSAGE: 'Please select up to 5 experience areas.',
    MONTHS : [
        'Day',
        'Week',
        'Month',
        'Year',
    ],

    WHEN_EXPERIENCED_PROBLEM:'When was the first time you experienced this problem?',
    COMPLAIN_IMAGE_PATH: BASE_URL + 'public/uploads/complains/',
    // COMPLAIN_IMAGE_PATH: 'http://ndp.apptestonline.com/neuro-diagnostics-stage/public/uploads/complains/',
    FORGOT_PASSWORD: 'Forgot your password?',
    Patient_Profile:'Patient Profile',
    USERNAME:'USERNAME',
    PASSWORD:'PASSWORD',
    Submit:'Submit',
    Close:'Close',
    Original_Narrative:'Original Narrative',
    Incomplete_Narrative:'Incomplete, Update Narrative',
    Cancel_Narrative:'Back to Patients',
    Accept_Narrative: 'Narrative is correct. Accept',

    IdleTimeOut: 5,
};

export const PROFILE_TEXT = {
    Patient_Profile :'Patient Profile',
    TITLE:'TITLE',
    Mr:'Mr.',
    Ms:'Ms.',
    FIRST_NAME:'FIRST NAME',
    LAST_NAME:'LAST NAME',
    DATE_OF_BIRTH:'DATE OF BIRTH',
    GENDER:'GENDER',
    Male:'Male',
    Female:'Female',
    EMAIL:'EMAIL',
    PHONE:'PHONE',
    Submit:'Submit',
}

export const MENU_ITEMS = {
    Pending_Narratives:'Pending Narratives',
    My_Profile:'My Profile',
    Settings:'Settings',
    Logout:'Logout',
    approved_narratives:'Approved Narratives'
}

export const URLS = {
    users : '/users',
    profiles : '/profiles',
    getQuestionsByComplainType  : '/get-questions-by-complain-type',
    getChiefComplainTypes       : '/get-cheif-complain-types',
    savePatientNarratives       : '/save-patient-narratives',
    thankyou: '/thankyou',
    master: '/master',
    login: '/login',
    pending_patient_narratives: '/pending-patient-narratives',
    patient_narratives_details: '/patient-narratives-details',
    patient_detail:'/get-patient-complain-detail',
    patient_options_detail:'/get-patient-options-detail',
    savePatientNarrativesById:'/save-narratives-by-patient-id',
    approvedPatientNarrative:'/approved-patient-narrative',
    patient_complains:'/patient-complains',
    patient_complain_detail:'/patient-complains-details',
    narrative_questions_detail:'/get-questions-by-narrative-id',
    update_patient_narrative:'/update-patient-narratives',
    search_question:'/search-question',
    save_search_question_option:'/save-search-question-options',
    get_additional_patient_narrative:'/get-additional-patient-narrative',
    save_pending_question:'/save-pending-question',
    user_profile:'/get-profile',
    delet_additional_info:'/delet-additional-info',
    
    
    
    
    
    
    
};


export function getAccessToken() {
    const surgeonData = JSON.parse(localStorage.getItem('userData'));
    if(surgeonData)
    {
        return surgeonData.token;
    }
    else{
        window.location.replace(window.location.pathname+'#/surgeon/login/');
    }

}

export function checkNull(val)
{
    if(val !== '' && val !== null && val !== undefined && val !== 'null')
        return true;
    else
        return false;
}

export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        return {};
    }
}

export function arrayUnion(arr1, arr2) {
    var union = arr1.concat(arr2);

    for (var i = 0; i < union.length; i++) {
        for (var j = i+1; j < union.length; j++) {
            if (areUsersEqual(union[i], union[j])) {
                union.splice(j, 1);
                j--;
            }
        }
    }

    return union;
}

export const  checkAuth =()=> {
    let data = localStorage.getItem('userData');
    if (!data)
    {
        window.location.replace(window.location.pathname+'#/surgeon/login/');
    }
}

export const getLoggedInData =()=> {
    let data = localStorage.getItem('userData');
    if (data)
    {
        return JSON.parse(data);
    }
    return false;
}

function areUsersEqual(g1, g2) {
    return g1.id === g2.id;
}

export function handleResponse(response)
{
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                // logout();
                // location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}

export function jsUcfirst(string)
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function menuOpen() {
    $(this).toggleClass('open');
};

export function sideMenuOpen() {
    $('.js-sideMenu').addClass("is--active");
    $('.c-side-nav').not(".is--open").addClass('is--open');
    $('body').addClass("is--menu");
}

export function sideMenuClose() {
    $('.js-sideMenu').removeClass("is--active");
    $('.c-side-nav.is--open').removeClass("is--open");
    $('body').removeClass("is--menu");
}
export function getAge(dateString) {
    var now = new Date();
    var today = new Date(now.getYear(),now.getMonth(),now.getDate());

    var yearNow = now.getYear();
    var monthNow = now.getMonth();
    var dateNow = now.getDate();

    var dob = new Date(dateString.substring(6,10),
        dateString.substring(0,2)-1,
        dateString.substring(3,5)
    );

    var yearDob = dob.getYear();
    var monthDob = dob.getMonth();
    var dateDob = dob.getDate();
    var age = {};
    var ageString = "";
    var yearString = "";
    var monthString = "";
    var dayString = "";


    var yearAge = yearNow - yearDob;

    if (monthNow >= monthDob)
        var monthAge = monthNow - monthDob;
    else {
        yearAge--;
        var monthAge = 12 + monthNow -monthDob;
    }

    if (dateNow >= dateDob)
        var dateAge = dateNow - dateDob;
    else {
        monthAge--;
        var dateAge = 31 + dateNow - dateDob;

        if (monthAge < 0) {
            monthAge = 11;
            yearAge--;
        }
    }

    age = {
        years: yearAge,
        months: monthAge,
        days: dateAge
    };

    if ( age.years > 1 ) yearString = " years";
    else yearString = " year";
    if ( age.months> 1 ) monthString = " months";
    else monthString = " month";
    if ( age.days > 1 ) dayString = " days";
    else dayString = " day";


    if ( (age.years > 0) && (age.months > 0) && (age.days > 0) )
        ageString = age.years +" "+ yearString+ " old";
    else if ( (age.years == 0) && (age.months == 0) && (age.days > 0) )
        ageString = age.days +" "+ dayString + " old";
    else if ( (age.years > 0) && (age.months == 0) && (age.days == 0) )
        ageString = age.years +" "+ yearString + " old";
    else if ( (age.years > 0) && (age.months > 0) && (age.days == 0) )
        ageString = age.years +" "+ yearString +" old";
    else if ( (age.years == 0) && (age.months > 0) && (age.days > 0) )
        ageString = age.months +" "+ monthString + " and " + age.days +" "+ dayString + " old";
    else if ( (age.years > 0) && (age.months == 0) && (age.days > 0) )
        ageString = age.years + yearString +" old";
    else if ( (age.years == 0) && (age.months > 0) && (age.days == 0) )
        ageString = age.months +"-"+ monthString + " old";
    else ageString = "";
    return ageString;
}

export function makeProfileSummary(profileData,data)
{


    let _profileSummary = profileData.title+" ";
    _profileSummary += profileData.first_name+" ";
    _profileSummary += profileData.last_name+" ";
    let year  = profileData.dob;
    let month  = profileData.dob;
    let day  = profileData.dob;
    year = year.substr(0,4);
    month = month.substr(5,2);
    day = day.substr(8,2);

    let date = month+"/"+day+"/"+year;
    let gender = (profileData.gender).toLowerCase();
    date = getAge(date);
    _profileSummary += "is a "+date+" "+gender+" ";
    //_profileSummary += "who has narrated ";
    var gender_verbs;
    var gender_pronouns;
    if(gender=='male')
    {
        
        gender_verbs = "his ";
        gender_pronouns = "he ";
        
    }
    else
    {   
        gender_pronouns = "she ";
        gender_verbs = "her ";
    }
    _profileSummary += "who was in "+gender_verbs+" usual state of health until ";
    /*if(gender=='male')
    {
      _profileSummary += "his ";
    }
    else
    {
      _profileSummary += "her ";
    }*/


    //_profileSummary += "complain(s) which is mentioned below; <br><br>";
    //var data_after = JSON.parse(data);
    //console.log(data);
    //console.log(data[0].optionData[data[0].optionData.length-1].narrative_text);
    let custom_data = localStorage.getItem("newData").trim();
    var CD = JSON.parse(custom_data);

    let complain_image_data = localStorage.getItem("data");
    let image_and_points = JSON.parse(complain_image_data);

  
    if(CD.length > 0)
    {
        for(var i =0; i <= CD.length-1; i++ )
        {

            //console.log('complainType:',complainType,'narrative_text',narrative_text);
            if( i == 0)
            {
                
                var complain_type_name = CD[i].complainType;
                var narrative_text = CD[i].answere[0].narrative_text;

                var myArray = narrative_text.split(/([0-9]+)/);

                _profileSummary += myArray[1]+" "+myArray[2];
                var complain_type_name_Lower =  complain_type_name.toLowerCase();
                _profileSummary += " when "+gender_pronouns+" first experienced the "+complain_type_name_Lower ;
                if(data.length==1)
                {
                    _profileSummary += ".";
                }
            }else{
                var complain_type_name = CD[i].complainType;
                var narrative_text = CD[i].answere[0].narrative_text;

                var myArray = narrative_text.split(/([0-9]+)/);
                var complain_type_name_Lower =  complain_type_name.toLowerCase();
                _profileSummary += (data.length-1==i?" as well as ": " , ")+complain_type_name_Lower+" since ";
                _profileSummary += myArray[1]+" "+myArray[2]+" <br>";
            }
        }
    }


    return {_profileSummary , image_and_points };
}

export const isTrueOrFalse=(value)=>{

    if(value===1){
        return true;
    }else if(value===0){
        return false;
    }else{
        return false;
    }
};
